import React from "react";

import { useTranslation } from "react-i18next";

import Markdown from "@components-shared/Markdown";
import { WrappedLink } from "@components/navigation";
import { useRootAppStore } from "@hooks";
import { useWalletGracePeriod } from "@state/hooks/wallet-grace-period/useWalletGracePeriod";
import { getCurrentCulture } from "@utils";

export default function WalletGracePeriodInfo() {
	const { t } = useTranslation("wallet-grace-period");
	const rootStore = useRootAppStore();
	const data = useWalletGracePeriod();
	if (!data) {
		return null;
	}

	const colorClass = data.isExpired ? "danger" : "warning";

	return (
		<div className="popup__col col col-sml-12">
			<div className="message message--base">
				<div className="message__content u-padd--reset">
					<div className="message__title u-type--xmed">
						<i
							className={`message__icon u-icon u-icon--lrg u-icon--alert-circle u-color--sent--${colorClass} u-mar--right--tny`}
						/>
						<span className="u-align--v--middle">
							{t("GRACE_PERIOD_POPUP_TITLE")}
						</span>
					</div>

					<Markdown
						className="message__text"
						content={data.message}
					/>

					{data.isExpired && (
						<div className="message__text u-mar--top--tny">
							{t("SLIP_HANDLING_INFO")}
						</div>
					)}

					<WrappedLink
						className={`at-welcomeModalBtnWalletActivation u-anchor u-anchor--${data.isExpired ? "primary" : "warning"} u-anchor--underline has-arrow`}
						to={`/${getCurrentCulture()}/auth/activate-wallet`}
						onClick={() => {
							rootStore.welcomeStore.hidePopup();
							rootStore.requiredUserActionStore.hidePopup();
						}}
					>
						{t("ACTIVATE_WALLET_LINK")}
					</WrappedLink>
				</div>
			</div>
		</div>
	);
}
